import React from 'react';
import './LoadingAnimation.css'; // Import the CSS file for styling

const LoadingAnimation = () => {
  return (
    <div className="loading-container">
      <div className="loading-spinner">
        <div className="spinner-glow"></div>
      </div>
      <p className="loading-text">Loading...</p>
    </div>
  );
};

export default LoadingAnimation;
